// ReviewStars component
"use client";

import React from 'react';
import { Rating, ThinStar } from '@smastrom/react-rating';
import { shadeColor } from "@/lib/utils";

interface ReviewStarsWithExampleProps {
  rating: number;
  hexColour: string;
  title: string | null;
  name: string | null;
}

const ReviewStarsWithExample: React.FC<ReviewStarsWithExampleProps> = ({ rating, hexColour, title, name }) => {

    const myStyles = {
        itemShapes: ThinStar,
        activeFillColor: hexColour,
        inactiveFillColor: shadeColor(hexColour, 50)
    };

    return (
    <div className="flex flex-col items-center justify-center text-center space-y-1 w-full mb-4 mt-2">
        <div className="flex items-center justify-center w-1/2">
        <Rating
        style={{ maxWidth: 130 }}
        value={rating}
        readOnly
        halfFillMode='svg'
        itemStyles={myStyles}
        />
        </div>
        {
            title && (
                <p className={`flex text-md font-bold leading-5 mx-4`}>&quot;{title.trim()}&quot;</p>
            )
        }
        {
            name && (
                <p className={`flex text-sm leading-5 mx-4`}>{name}</p>
            )
        }
    </div>
    );
};

export default ReviewStarsWithExample;